module.exports = __webpack_public_path__ + "static/img/01.9872071d.png";